export const DURATION_OPTIONS = {
  'less-than-1-year': 'Less than 1 year',
  '1-2-years': '1-2 years',
  '2-5-years': '2-5 years',
  '5-plus-years': '5+ years'
} as const;

export const BRAND_VIBE_OPTIONS = {
  'technical-expert': 'Technical Expert',
  'strategic-advisor': 'Strategic Advisor',
  'hands-on-builder': 'Hands-on Builder',
  'business-focused': 'Business-Focused',
  'startup-specialist': 'Startup Specialist',
  'enterprise-consultant': 'Enterprise Consultant'
} as const;

export const CLIENT_ACQUISITION_OPTIONS = {
  'mostly-outreach': 'Mostly outreach',
  'mostly-inbound': 'Mostly inbound',
  'balanced-mix': 'Balanced inbound/outreach',
  'referrals-only': 'Referrals only'
} as const;

export const CLIENT_COUNT_OPTIONS = {
  '1-2': '1-2 clients',
  '3-5': '3-5 clients',
  '6-10': '6-10 clients',
  '10+': '10+ clients'
} as const;

export const LONG_TERM_OPTIONS = {
  'long-game': 'This is my long-term career path',
  'in-between': 'Transitional phase between roles',
  'experimenting': 'Still experimenting/figuring it out',
  'semi-retirement': 'Semi-retirement approach'
} as const;

export const MARKETING_TIME_OPTIONS = {
  'dedicated-hours': 'Set aside dedicated hours weekly',
  'between-projects': 'Only between projects',
  'always-on': 'Always networking/marketing',
  'minimal-effort': 'Minimal - rely on reputation',
  'hate-it': 'Honestly, I hate marketing'
} as const;

export const SURVEY_STATUS_OPTIONS = {
  'new': 'New',
  'submitted': 'Submitted',
  'completed': 'Completed',
  'completed by user': 'Completed by user',
  'closed': 'Closed'
} as const;

/** Admin group for Fractional Pulse / peer cohort subscriber_field_definitions. */
export const CTO_SURVEY_FIELD_ADMIN_GROUP = 'Fractional Pulse';

/**
 * Map cto_survey columns → subscriber custom field keys.
 * Stored select values use the human labels (Engine convention), not slugs.
 * Use with the *OPTIONS maps above when porting rows into custom_data.
 */
export const CTO_SURVEY_FIELD_KEYS = {
  status: 'cto_survey_status',
  duration: 'cto_survey_duration',
  brand_vibe: 'cto_survey_brand_vibe',
  client_acquisition: 'cto_survey_client_acquisition',
  client_count: 'cto_survey_client_count',
  long_term: 'cto_survey_long_term',
  marketing_time: 'cto_survey_marketing_time',
  additional_notes: 'cto_survey_additional_notes',
} as const;

export type CtoSurveyColumn = keyof typeof CTO_SURVEY_FIELD_KEYS;

const CTO_SURVEY_OPTION_MAPS: Record<
  CtoSurveyColumn,
  Record<string, string>
> = {
  status: SURVEY_STATUS_OPTIONS,
  duration: DURATION_OPTIONS,
  brand_vibe: BRAND_VIBE_OPTIONS,
  client_acquisition: CLIENT_ACQUISITION_OPTIONS,
  client_count: CLIENT_COUNT_OPTIONS,
  long_term: LONG_TERM_OPTIONS,
  marketing_time: MARKETING_TIME_OPTIONS,
};

/** Convert a legacy cto_survey slug to the Engine select label (or null if unknown). */
export function ctoSurveySlugToLabel(
  column: CtoSurveyColumn,
  slug: string | null | undefined,
): string | null {
  if (!slug || !slug.trim()) return null;
  const map = CTO_SURVEY_OPTION_MAPS[column];
  return map[slug] ?? null;
}